import styled from "styled-components";

export const LineBreakReflectSpan = styled.span`
white-space: pre-wrap;
`